import { useLayoutEffect, useState } from 'react';

// use html anchor points to attach csv edges and pins ---
export function usePinAnchors(containerRef, deps = []) {
  const [pinAnchors, setPinAnchors] = useState({});

  useLayoutEffect(() => {
    if (!containerRef.current) return;

    const rectContainer = containerRef.current.getBoundingClientRect();
    const anchors = {};

    document.querySelectorAll('.pin-anchor').forEach((el) => {
      const nodeId = el.dataset.nodeId;
      const rect = el.getBoundingClientRect();

      anchors[nodeId] = {
        x: rect.left + rect.width / 2 - rectContainer.left,
        y: rect.top + rect.height / 2 - rectContainer.top,
      };
    });

    setPinAnchors(anchors);
  }, deps);

  return pinAnchors;
}
